'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgSendOutlined(props) {
    return (React__default.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", width: "1em", viewBox: "0 0 24 24", ...props },
        React__default.default.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
        React__default.default.createElement("path", { d: "M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z", fill: "currentColor" })));
}

module.exports = SvgSendOutlined;
//# sourceMappingURL=Send.js.map
